// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"174":"64f136e0","672":"32e3a4d6","753":"676d68b3","777":"676d68b3","975":"ebc68e0b"}[chunkId] + ".chunk.css";
};